import { useEffect, useState } from "react";
import { Button, Form, Input, Spin, Typography } from "antd";
import { LockOutlined, UserOutlined, LoadingOutlined } from "@ant-design/icons";
import { ConnectedProps } from "react-redux";
import { jwtDecode } from "jwt-decode";

import logo from "../../../images/logo.svg";
import { LoginFieldType } from "../../../models";
import connector from "./Container";
import { history } from "../../../utils";

const ResetPassword = ({
  actions,
  state,
}: ConnectedProps<typeof connector>) => {
  const { loading } = state;
  const [token, setToken] = useState("");
  const [email, setEmail] = useState<string | undefined>("");

  useEffect(() => {
    const TOKEN_SUBSTRING = 7;
    const userToken = history.location.search.substring(TOKEN_SUBSTRING);

    if (userToken) {
      setToken(userToken);
      setEmail(jwtDecode(userToken).sub);
    }
  }, []);

  const onFinish = (values: LoginFieldType) => {
    !token
      ? actions.sendResetPasswordEmail(values.email)
      : actions.resetPassword(email, values.password, token);
  };

  return (
    <div className="flex flex-col h-screen items-center justify-center bg-secondary">
      <div className="pb-10 text-offer-blue pt-20 rounded-md w-5/6 sm:w-[450px] m-auto shrink-0 bg-base-gray flex flex-col items-center justify-center">
        <img width={150} src={logo} alt="logo" className="mb-6" />

        <Form
          name="basic"
          className="w-[90%] sm:w-4/5"
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
        >
          {!token ? (
            <Form.Item<LoginFieldType>
              name="email"
              rules={[
                {
                  required: true,
                  message: "Unesite email!",
                },
                { type: "email" },
              ]}
            >
              <Input
                type="email"
                prefix={<UserOutlined className="text-offer-blue pr-2" />}
                className="h-10 text-[16px] "
                placeholder="email"
              />
            </Form.Item>
          ) : (
            <Form.Item<LoginFieldType>
              name="password"
              rules={[
                {
                  required: true,
                  message: "Unesite lozinku!",
                },
                { min: 6 },
              ]}
            >
              <Input.Password
                prefix={<LockOutlined className="text-offer-blue pr-2" />}
                className="h-10 text-[16px] "
                placeholder="lozinka"
              />
            </Form.Item>
          )}

          <Form.Item>
            <Button
              type="primary"
              className="text-white font-medium w-full h-10 text-[16px] bg-offer-blue rounded-none"
              htmlType="submit"
            >
              {!token ? "POŠALJI" : "SPREMI"}
            </Button>
          </Form.Item>
          {loading && (
            <div className="text-center">
              <Spin
                indicator={
                  <LoadingOutlined className="text-secondary text-3xl" spin />
                }
              />
            </div>
          )}
        </Form>
      </div>
    </div>
  );
};

export default ResetPassword;
